import React, { useEffect, useState } from "react";
import { Search } from "react-feather";
import { Row, Col, Form } from "reactstrap";
import { debounce } from "lodash";
import { useForm } from "react-hook-form";
const SearchTable = ({ setSearchData, setFilterData, searchData, setFilterType, setQFName, setQFValue, placeholder, isPhoneNumber }) => {
  const [isFocus, setIsFocus] = useState(false)
  const { register, watch, reset, handleSubmit, setValue } = useForm();

  useEffect(() => {
    if (!searchData) {
      reset()
    } else {
      setValue("searchtable", searchData)
    }
  }, [searchData])
  const onInputChange = (formValues) => {
    let value = formValues.searchtable
    value=value.trim();
    setFilterType('search');
    setSearchData(value);
    setFilterData([]);
    try {
      setQFName("");
      setQFValue("");
    } catch (err) {

    }

  }
  let searchTableInput = watch('searchtable');

  // const debounceData = debounce(onInputChange, 1500);
  return (
    <Form onSubmit={handleSubmit(onInputChange)}>
      <div className={`input-field ${searchTableInput ? 'input-active' : ''}`}>
        <input type="text" placeholder={placeholder ? placeholder : ""} {...register('searchtable', {
          onChange: (e) => {
            if (isPhoneNumber) {
              setValue('searchtable', e.target.value.replace(/[^0-9]/g, ''))
            } else {
              setValue('searchtable', e.target.value)
            }
          }
        })} maxLength={isPhoneNumber ? 10 : ""} onFocus={() => setIsFocus(true)} onBlur={() => setIsFocus(false)} />
        <label htmlFor="searchtable">Search</label>
        <button className="submit-search" type="submit">{isFocus ? <i className="fa fa-check"></i> : <i className="fa fa-search"></i>}</button>
      </div>
    </Form>
  );
};

export default SearchTable;
